import React from 'react';
import { motion } from 'framer-motion';
import { ContactSection } from '../components/ContactSection';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export const Contact = () => {
  return (
    <div className="pt-20">
      {/* Page Header */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 text-white overflow-hidden">
        {/* Decorative Background */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-300 rounded-full filter blur-3xl"></div>
        </div>
        
        {/* Floating Elements */}
        <motion.div
          animate={{ y: [0, -20, 0] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-20 left-10 w-16 h-16 bg-white/10 rounded-lg backdrop-blur-sm"
        />
        <motion.div
          animate={{ y: [0, 20, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-20 right-10 w-20 h-20 bg-white/10 rounded-full backdrop-blur-sm"
        />

        <div className="container mx-auto px-4 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center space-y-6"
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring" }}
              className="inline-flex items-center justify-center w-20 h-20 bg-white/10 backdrop-blur-lg rounded-2xl mb-4"
            >
              <Mail className="h-10 w-10 text-white" />
            </motion.div>
            <h1 className="text-5xl lg:text-6xl font-bold">
              Contact Us
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Get in touch with us to discuss your training needs. We're here to help you achieve excellence.
            </p>
            
            {/* Quick Contact Info */}
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto pt-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-6"
              >
                <Phone className="h-6 w-6 mx-auto mb-3" />
                <div className="text-sm text-blue-100">Call Us</div>
                <div className="font-semibold">044 49591335</div>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-6"
              >
                <Mail className="h-6 w-6 mx-auto mb-3" />
                <div className="text-sm text-blue-100">Email Us</div>
                <div className="font-semibold">training@isde.academy</div>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-6"
              >
                <Clock className="h-6 w-6 mx-auto mb-3" />
                <div className="text-sm text-blue-100">Working Hours</div>
                <div className="font-semibold">Mon - Sat: 9AM - 6PM</div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      <ContactSection />
    </div>
  );
};
